module.exports = __webpack_public_path__ + "img/arrow-left.5ffd5a3f.svg";